import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import InquiryService from '../../../service/inquiry/inquiry';

interface InquiryPopUpProps {
  showInquiryPopUp: boolean;
  setShowInquiryPopUp: (value: boolean) => void;
  inquiryType: string; // inquiryType prop 추가 컨설팅문의, 문의하기 값이 넘어옴
}

// const AffiliationType = [
//   { name: '금융기관', value: '금융기관' },
//   { name: '대부중개업체', value: '대부중개업체' },
//   //   { name: '자산운용사', value: '자산운용사' },
//   //   { name: '디펠로퍼', value: '디펠로퍼' },
//   { name: '기업', value: '기업' },
//   { name: '개인', value: '개인' },
//   { name: '기타', value: '기타' },
// ];
const MainInquiryPopUp = ({
  showInquiryPopUp,
  setShowInquiryPopUp,
  inquiryType,
}: InquiryPopUpProps) => {
  // const [type, setType] = useState('N');
  // const [purpose, setPurpose] = useState('N');
  // const [affiliation, setAffiliation] = useState('');
  const [title, setTitle] = useState('');
  const [email, setEmail] = useState('');
  // const [phone, setPhone] = useState('');
  const [content, setContent] = useState('');
  // const [phoneError, setPhoneError] = useState(false);
  const [loading, setLoading] = useState(false);

  // const TitleContent = (inquiryType: string) => {
  //   if (inquiryType === 'Inquiry') {
  //     return (
  //       <>
  //         <div>1:1 문의를 주시면</div>
  //         <div>신속하게 연락 드리겠습니다.</div>
  //       </>
  //     );
  //   } else if (inquiryType === 'Consulting') {
  //     return (
  //       <>
  //         <div>컨설팅 문의를 주시면</div>
  //         <div>신속하게 연락 드리겠습니다.</div>
  //       </>
  //     );
  //   } else {
  //     return (
  //       <>
  //         <div>사업제휴 문의를 주시면</div>
  //         <div>신속하게 연락 드리겠습니다.</div>
  //       </>
  //     );
  //   }
  // };

  useEffect(() => {
    if (showInquiryPopUp) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showInquiryPopUp]);

  const Submit = async () => {
    setLoading(true);
    try {
      const data = {
        // address: affiliation + ' / ' + title,
        // type: inquiryType === 'Inquiry' ? 'O' : 'Q',
        category: '계정/로그인 문의',
        content: content,
        email: email,
        //phone: String(phone),
      };
      try {
        await InquiryService.inquiry(data);
        alert('문의가 접수되었습니다. 빠른 시일 내에 답변드리겠습니다.');
        setShowInquiryPopUp(false);
      } catch (error) {
        console.error('Error submitting form:', error);
        alert('문의 접수에 실패했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      console.error('Submit 함수에서 에러 발생:', error);
    } finally {
      setLoading(false);
    }
  };

  const isFormComplete = email && content && email.includes('@');

  return (
    <Overlay>
      <PopupWrapper>
        <Popup>
          <TitleBox>
            <Title>문의하기</Title>
            <CloseButton onClick={() => setShowInquiryPopUp(false)}>
              <img src="/assets/images/close/close-dark-gray.svg" alt="Close" />
            </CloseButton>
          </TitleBox>
          <ContentBox>
            <InputBox>
              <InputItem>
                <InputTitle>답변받으실 이메일</InputTitle>
                <Input
                  placeholder="회신 받을 이메일을 입력해주세요."
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <SubItem>
                  <SubTitle>정확한 이메일 주소를 기입해 주세요.</SubTitle>
                </SubItem>
                {!email.includes('@') && email.length > 0 && (
                  <InputError>이메일 형식이 올바르지 않습니다.</InputError>
                )}
              </InputItem>
              <InputItem>
                <InputTitle>문의 유형</InputTitle>
                <Drop>
                  <span>계정/로그인 문의</span>
                </Drop>
              </InputItem>
              <InputItem>
                <InputTitle>
                  <span>문의내용</span>
                </InputTitle>
                <Textarea
                  placeholder="땅집고옥션 이용 중에 생긴 불편한 사항이나 문의사항을 남겨주세요."
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  maxLength={1000}
                />
                <ContentMaxLength>
                  <span style={{ color: 'black' }}>{content.length}</span> /
                  1000
                </ContentMaxLength>
              </InputItem>
            </InputBox>
          </ContentBox>
          <SubmitButtonContainer>
            <SubmitButton
              disabled={!isFormComplete}
              isComplete={!!isFormComplete}
              onClick={Submit}
            >
              {loading ? '로딩 중...' : '접수'}
            </SubmitButton>
          </SubmitButtonContainer>
        </Popup>
      </PopupWrapper>
    </Overlay>
  );
};

export default MainInquiryPopUp;

interface AffiliationTypeProps {
  active: boolean;
}
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.52);
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const PopupWrapper = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const Popup = styled.div`
  width: 100%;
  height: 90%;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
`;

const TitleBox = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  box-sizing: border-box;
`;

const Title = styled.div`
  flex: 1;
  text-align: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #171e26;
`;

const CloseButton = styled.div`
  cursor: pointer;
  margin-right: 16px;
`;

const ContentBox = styled.div`
  width: 100%;
  height: calc(100% - 150px);
  padding: 16px 16px 48px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  overflow-y: auto;
`;

const InputBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const InputItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 700;
  color: #616161;
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const SubItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #eaf2fe;
  height: 35px;
  padding: 8px 12px;
  border-radius: 4px;
`;

const SubTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  color: #616161;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Drop = styled.div`
  width: 100%;
  padding: 13px;
  border: 1px solid rgba(23, 30, 38, 0.1);
  border-radius: 5px;
  font-size: 14px;
  color: rgba(23, 30, 38, 0.56);
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 13px;
  border: 1px solid rgba(23, 30, 38, 0.1);
  border-radius: 5px;
`;

const Textarea = styled.textarea`
  width: 100%;
  height: 274px !important;
  padding: 12px 16px;
  border: 1px solid rgba(23, 30, 38, 0.1);
  border-radius: 5px;
  height: 100px;
  resize: none;
  outline: none;
`;

const InputError = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  color: rgba(236, 79, 79, 1);
  margin-top: 4px;
  display: block;
`;

const ContentMaxLength = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  color: rgba(23, 30, 38, 0.4);
  align-self: flex-end;
`;

const SubmitButtonContainer = styled.div`
  padding: 16px 16px 40px;
  width: 100%;
  background-color: #fff;
`;

const SubmitButton = styled.button<{ isComplete: boolean }>`
  width: 100%;
  height: 54px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isComplete }) => (isComplete ? '#008AFF' : '#f0f0f0')};
  color: ${({ isComplete }) =>
    isComplete ? '#fff' : 'rgba(23, 30, 38, 0.40)'};
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  border: none;
  cursor: pointer;
`;
